import styled from 'styled-components';
import { rem } from 'polished';

export const Wrapper = styled.section`
  header {
    margin-bottom: ${rem(40)};

    aside {
      margin-bottom: ${rem(24)};
    }

    @media only screen and (min-width: 840px) {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;

      aside {
        margin-bottom: auto;
      }
    }
  }

  .loader {
    margin-top: ${rem(32)};
  }
`;
